"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Youtube;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import React from 'react';
// export default function Youtube(props) {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={100} height={100} {...props}>
//       <title>YouTube</title>
//       <g id="Social_media" data-name="Social media">
//         <path id="youtube" d="M88.328,30.676a10.055,10.055,0,0,0-7.073-7.119C75.017,21.875,50,21.875,50,21.875s-25.017,0-31.256,1.682a10.054,10.054,0,0,0-7.072,7.119C10,36.956,10,50.057,10,50.057s0,13.1,1.672,19.38a9.9,9.9,0,0,0,7.072,7.006C24.983,78.125,50,78.125,50,78.125s25.016,0,31.255-1.682a9.9,9.9,0,0,0,7.073-7.006C90,63.158,90,50.057,90,50.057S90,36.956,88.328,30.676ZM41.818,61.952V38.162l20.909,11.9Z" />
//       </g>
//     </svg>
//   );
// }
function Youtube(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".youtube0{fill:#FFFFFF !important;}.youtube1{fill:#FF0000 !important;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "youtube0",
    d: "M11.4,17.1L7.8,17c-1.2,0-2.3,0-3.5-0.2c-1.7-0.4-1.9-2.1-2-3.6C2.1,11.2,2.2,9.1,2.5,7 c0.2-1.1,0.9-1.8,2.1-1.9C8.5,4.9,12.4,4.9,16.3,5c0.4,0,0.8,0.1,1.2,0.1c2,0.3,2,2.3,2.2,4c0.1,1.7,0.1,3.4-0.2,5 c-0.2,1.4-0.6,2.5-2.2,2.7C15.4,17,13.4,17.1,11.4,17.1C11.4,17.1,11.4,17.1,11.4,17.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "youtube1",
    d: "M9.3,13.6c1.5-0.9,3-1.7,4.5-2.6c-1.5-0.9-3-1.7-4.5-2.6V13.6z"
  }));
}